import {inject, injectable} from "inversify";
import {Bindings} from "data/constants/bindings";
import type {IApiResponse, IHttpClientService} from "data/services/http";
import {AxiosResponse} from "axios";

export interface IRankingsPayload {
	page?: number;
	gamedayId?: number | null;
}

export interface IRankings {
	userId: number | null;
	userName: string;
	leagueId: number | null;
	gamedayId: number | null;
	rank: number | null;
	points: number | null;
	margin: number | null;
	overallRank: number;
	overallPoints: number;
	overallMargin: number;
}

export interface IRankingsResponse {
	rankings: IRankings[];
	user: IRankings | null;
	nextPage: boolean;
}

export interface ILeagueRankingPayload {
	leagueId: number;
	gamedayId: number;
	page?: number;
	limit?: number;
}

export interface IGamebarPayload {
	gamedayId: number;
}

export interface IGamebarResponse {
	gamedayRank: number | null;
	overallRank: number | null;
	gamedayPoints: number | null;
	overallPoints: number | null;
}

export type TLeaderboardResponse = IApiResponse<IRankingsResponse>;
export type TGamebarResponse = IApiResponse<IGamebarResponse>;

export interface IRankingsApiProvider {
	leaderboard: (params: IRankingsPayload) => Promise<AxiosResponse<TLeaderboardResponse>>;
	league_ranking: (params: ILeagueRankingPayload) => Promise<AxiosResponse<TLeaderboardResponse>>;
	gamebar: (params: IGamebarPayload) => Promise<AxiosResponse<TGamebarResponse>>;
}

@injectable()
export class RankingsApiProvider implements IRankingsApiProvider {
	constructor(@inject(Bindings.ApiHTTPClient) private _http: IHttpClientService) {}

	leaderboard = (payload: IRankingsPayload) =>
		this._http.get<TLeaderboardResponse>(`fantasy/ranking/country`, payload);
	league_ranking = ({leagueId, ...params}: ILeagueRankingPayload) =>
		this._http.get<TLeaderboardResponse>(`fantasy/ranking/league/${leagueId}`, params);
	gamebar = (params: IGamebarPayload) =>
		this._http.get<TGamebarResponse>(`fantasy/ranking/gamebar`, params);
}
